"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ASPECT_RATIO_CONFIG = exports.CustomLogoSize = exports.BurnPosition = exports.SoundwaveType = exports.ProgressType = exports.AspectFit = exports.AspectRatio = exports.BurnQuality = exports.BackgroundStyle = exports.AligmentStyle = void 0;
var AligmentStyle;
(function (AligmentStyle) {
    AligmentStyle[AligmentStyle["BottomLeft"] = 1] = "BottomLeft";
    AligmentStyle[AligmentStyle["BottomCenter"] = 2] = "BottomCenter";
    AligmentStyle[AligmentStyle["BottomRight"] = 3] = "BottomRight";
    AligmentStyle[AligmentStyle["CenterLeft"] = 4] = "CenterLeft";
    AligmentStyle[AligmentStyle["CenterCenter"] = 5] = "CenterCenter";
    AligmentStyle[AligmentStyle["CenterRight"] = 6] = "CenterRight";
    AligmentStyle[AligmentStyle["TopLeft"] = 7] = "TopLeft";
    AligmentStyle[AligmentStyle["TopCenter"] = 8] = "TopCenter";
    AligmentStyle[AligmentStyle["TopRight"] = 9] = "TopRight";
})(AligmentStyle = exports.AligmentStyle || (exports.AligmentStyle = {}));
var BackgroundStyle;
(function (BackgroundStyle) {
    BackgroundStyle["None"] = "None";
    BackgroundStyle["Outline"] = "Outline";
    BackgroundStyle["DropShadow"] = "Drop shadow";
    BackgroundStyle["Background"] = "Background";
    // TODO: Investigate how to implement this
    // FullWidth = "Full Width"
})(BackgroundStyle = exports.BackgroundStyle || (exports.BackgroundStyle = {}));
var BurnQuality;
(function (BurnQuality) {
    BurnQuality["Low"] = "Low";
    BurnQuality["Medium"] = "Medium";
    BurnQuality["High"] = "High";
})(BurnQuality = exports.BurnQuality || (exports.BurnQuality = {}));
var AspectRatio;
(function (AspectRatio) {
    AspectRatio["Landscape"] = "16:9";
    AspectRatio["Portrait"] = "9:16";
    AspectRatio["Square"] = "1:1";
    AspectRatio["Vertical"] = "4:5";
    AspectRatio["Original"] = "Original";
})(AspectRatio = exports.AspectRatio || (exports.AspectRatio = {}));
var AspectFit;
(function (AspectFit) {
    AspectFit["Crop"] = "crop";
    AspectFit["Border"] = "border";
})(AspectFit = exports.AspectFit || (exports.AspectFit = {}));
var ProgressType;
(function (ProgressType) {
    ProgressType["BarOne"] = "Progress bar one";
    ProgressType["BarFour"] = "Progress bar four";
    ProgressType["CircleTwo"] = "Progress circle two";
})(ProgressType = exports.ProgressType || (exports.ProgressType = {}));
var SoundwaveType;
(function (SoundwaveType) {
    SoundwaveType["Fill"] = "cline";
    SoundwaveType["Centre"] = "line";
    SoundwaveType["Line"] = "p2p"; // p2p
})(SoundwaveType = exports.SoundwaveType || (exports.SoundwaveType = {}));
var BurnPosition;
(function (BurnPosition) {
    BurnPosition["TopLeft"] = "Top Left";
    BurnPosition["TopRight"] = "Top Right";
    BurnPosition["BottomLeft"] = "Bottom Left";
    BurnPosition["BottomRight"] = "Bottom Right";
    BurnPosition["BottomCenter"] = "Bottom Center";
})(BurnPosition = exports.BurnPosition || (exports.BurnPosition = {}));
var CustomLogoSize;
(function (CustomLogoSize) {
    CustomLogoSize["Small"] = "Small";
    CustomLogoSize["Medium"] = "Medium";
    CustomLogoSize["Large"] = "Large";
})(CustomLogoSize = exports.CustomLogoSize || (exports.CustomLogoSize = {}));
exports.DEFAULT_ASPECT_RATIO_CONFIG = {
    originalRatio: AspectRatio.Original,
    ratio: AspectRatio.Original,
    fit: AspectFit.Border,
    color: "#000000"
};
//# sourceMappingURL=media-config.js.map